import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import queue from '@nullvoxpopuli/ember-composable-helpers/helpers/queue';
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';

import classMod from 'rise-ui/helpers/class-mod.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import fnx from 'rise-ui/helpers/fnx.js';
import one from 'rise-ui/helpers/one.js';

export default class ClearButtonComponent extends Component {
  <template>
    {{#let (one @title "Clear") as | title |}}
    <button type="button"
      class={{classMod (concatClasses "c-clear-button" @class) @disabled "--disabled"}}
      title={{title}}
      {{on "click" (queue (fnx @action) (stopPropagation))}}
      ...attributes
    >
      {{~#if (has-block)}}{{yield}}{{else~}}Clear{{~/if~}}
    </button>
    {{/let}}
  </template>
}
